import React, { createContext, useContext, useState, useEffect } from 'react';

type Mode = 'dark' | 'light';

type ThemeContextType = {
  mode: Mode;
  toggleMode: () => void;
};

const ThemeContext = createContext<ThemeContextType | undefined>(undefined);

export const ThemeProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [mode, setModeState] = useState<Mode>(() => {
    const saved = localStorage.getItem('mode');
    return (saved === 'light' ? 'light' : 'dark') as Mode;
  });

  const toggleMode = () => {
    const next = mode === 'dark' ? 'light' : 'dark';
    setModeState(next);
    localStorage.setItem('mode', next);
  };

  useEffect(() => {
    document.documentElement.classList.toggle('light-mode', mode === 'light');
  }, [mode]);

  return (
    <ThemeContext.Provider value={{ mode, toggleMode }}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (!context) throw new Error('useTheme must be used within ThemeProvider');
  return context;
};
